
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {Button} from "@mui/material";
import EmailValidator from "email-validator";
import CirculerLoader from "../../components/Loader";
const ResetPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  //  const email = location.state?.email;
  const conTinue = async () => {
    const baseURL = process.env.REACT_APP_BASE_URL;
    const isvalidEmail = EmailValidator.validate(email.trim());
    if (email.trim() === "" || isvalidEmail === false) {
      setError(true);
    }else{
      setError(false);
    }
    if (email.trim() !== "" && isvalidEmail) {
      try {
        setLoading(true)
        const response = await axios.post(`${baseURL}/user/forgetEmailPassword`, {
          email: email.toLowerCase(),
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        if (response.data?.code !== 400) {
          navigate("/", { state: { email } });
        } else {
          alert("Email does not exist.");
        }
        setLoading(false)
      } catch (error) {
        setLoading(false)
        console.log("error")
        // console.error('Error creating user:', error.response ? error.response.data : error.message);
      }

    }
  }

  useEffect(() => {
    if (location.state?.email) {
      setEmail(location.state?.email)
    }
  }, [])
  return (
    <>
    {loading && <CirculerLoader/>}
    <div className="reset-password">
      <div className="reset-password-inner">

     
      <h1>Reset your password</h1>
      <p>Enter your Phone number or Email address and we will send you instructions to reset your password.</p>
      <div>
        <div className="input-container">
          <input type="email"
            value={email}
            onChange={(e) => { setEmail(e.target.value) }}
            placeholder=" "
          />
          <label >Email address*</label>
        </div>
        {(error || email.trim() === "") && <p style={{ color: "red" }}>Email is not valid.</p>}
        <Button onClick={conTinue} variant="contained" sx={{ textTransform: "none" }}> Continue</Button>
        <div className="back-to">
          <Link to="/authorize?type=login">Back to login
          </Link>
        </div>

   
      </div>
      </div>
      </div>
      <div className="footer-innner-reset">

<p className="term-part" >
	  <a href="#" >Terms of Use</a>  |  <a href="#" >Privacy Policy</a>
	</p>
</div>
    </>
  );
}
export default ResetPassword;